const actions = {
    PARTNER_READ_REQUEST: 'PARTNER_READ_REQUEST',
    PARTNER_READ_SUCCESS: 'PARTNER_READ_SUCCESS',
    PARTNER_READ_ERROR: 'PARTNER_READ_ERROR',
    PARTNER_UPDATE_PAYMENT_METHOD_REQUEST: 'PARTNER_UPDATE_PAYMENT_METHOD_REQUEST',
    PARTNER_UPDATE_PAYMENT_METHOD_SUCCESS: 'PARTNER_UPDATE_PAYMENT_METHOD_SUCCESS',
    PARTNER_UPDATE_PAYMENT_METHOD_ERROR: 'PARTNER_UPDATE_PAYMENT_METHOD_ERROR',
    PARTNER_DELETE_PAYMENT_METHOD_REQUEST: 'PARTNER_DELETE_PAYMENT_METHOD_REQUEST',
    PARTNER_DELETE_PAYMENT_METHOD_SUCCESS: 'PARTNER_DELETE_PAYMENT_METHOD_SUCCESS',
    PARTNER_DELETE_PAYMENT_METHOD_ERROR: 'PARTNER_DELETE_PAYMENT_METHOD_ERROR',
    PARTNER_UPDATE_PARTNER_PROFILE_REQUEST: 'PARTNER_UPDATE_PARTNER_PROFILE_REQUEST',
    PARTNER_UPDATE_PARTNER_PROFILE_SUCCESS: 'PARTNER_UPDATE_PARTNER_PROFILE_SUCCESS',
    PARTNER_UPDATE_PARTNER_PROFILE_ERROR: 'PARTNER_UPDATE_PARTNER_PROFILE_ERROR',
    PARTNER_CREATE_CLIENT_REQUEST: 'PARTNER_CREATE_CLIENT_REQUEST',
    PARTNER_CREATE_CLIENT_SUCCESS: 'PARTNER_CREATE_CLIENT_SUCCESS',
    PARTNER_CREATE_CLIENT_ERROR: 'PARTNER_CREATE_CLIENT_ERROR',
    PARTNER_READ_CLIENTS_REQUEST: 'PARTNER_READ_CLIENTS_REQUEST',
    PARTNER_READ_CLIENTS_SUCCESS: 'PARTNER_READ_CLIENTS_SUCCESS',
    PARTNER_READ_CLIENTS_ERROR: 'PARTNER_READ_CLIENTS_ERROR',
    PARTNER_READ_CLIENT_REQUEST: 'PARTNER_READ_CLIENT_REQUEST',
    PARTNER_READ_CLIENT_SUCCESS: 'PARTNER_READ_CLIENT_SUCCESS',
    PARTNER_READ_CLIENT_ERROR: 'PARTNER_READ_CLIENT_ERROR',

    PARTNER_READ_BILLING_ESTIMATE_REQUEST: 'PARTNER_READ_BILLING_ESTIMATE_REQUEST',
    PARTNER_READ_BILLING_ESTIMATE_SUCCESS: 'PARTNER_READ_BILLING_ESTIMATE_SUCCESS',
    PARTNER_READ_BILLING_ESTIMATE_ERROR: 'PARTNER_READ_BILLING_ESTIMATE_ERROR',

    PARTNER_READ_REFERRALS_REQUEST: 'PARTNER_READ_REFERRALS_REQUEST',
    PARTNER_READ_REFERRALS_SUCCESS: 'PARTNER_READ_REFERRALS_SUCCESS',
    PARTNER_READ_REFERRALS_ERROR: 'PARTNER_READ_REFERRALS_ERROR',
    PARTNER_CHANGE_SUBSCRIPTION_REQUEST: 'PARTNER_CHANGE_SUBSCRIPTION_REQUEST',
    PARTNER_CHANGE_SUBSCRIPTION_SUCCESS: 'PARTNER_CHANGE_SUBSCRIPTION_SUCCESS',
    PARTNER_CHANGE_SUBSCRIPTION_ERROR: 'PARTNER_CHANGE_SUBSCRIPTION_ERROR',
    PARTNER_CANCEL_SUBSCRIPTION_REQUEST: 'PARTNER_CANCEL_SUBSCRIPTION_REQUEST',
    PARTNER_CANCEL_SUBSCRIPTION_SUCCESS: 'PARTNER_CANCEL_SUBSCRIPTION_SUCCESS',
    PARTNER_CANCEL_SUBSCRIPTION_ERROR: 'PARTNER_CANCEL_SUBSCRIPTION_ERROR',
    PARTNER_REQUEST_TO_TRANSFER_REQUEST: 'PARTNER_REQUEST_TO_TRANSFER_REQUEST',
    PARTNER_REQUEST_TO_TRANSFER_SUCCESS: 'PARTNER_REQUEST_TO_TRANSFER_SUCCESS',
    PARTNER_REQUEST_TO_TRANSFER_ERROR: 'PARTNER_REQUEST_TO_TRANSFER_ERROR',
    PARTNER_SUBSCRIBE_SUBSCRIPTION_REQUEST: 'PARTNER_SUBSCRIBE_SUBSCRIPTION_REQUEST',
    PARTNER_SUBSCRIBE_SUBSCRIPTION_SUCCESS: 'PARTNER_SUBSCRIBE_SUBSCRIPTION_SUCCESS',
    PARTNER_SUBSCRIBE_SUBSCRIPTION_ERROR: 'PARTNER_SUBSCRIBE_SUBSCRIPTION_ERROR',
    PARTNER_DELETE_CLIENT_REQUEST: 'PARTNER_DELETE_CLIENT_REQUEST',
    PARTNER_DELETE_CLIENT_SUCCESS: 'PARTNER_DELETE_CLIENT_SUCCESS',
    PARTNER_DELETE_CLIENT_ERROR: 'PARTNER_DELETE_CLIENT_ERROR',
    PARTNER_READ_TRANSACTIONS_REQUEST: 'PARTNER_READ_TRANSACTIONS_REQUEST',
    PARTNER_READ_TRANSACTIONS_SUCCESS: 'PARTNER_READ_TRANSACTIONS_SUCCESS',
    PARTNER_READ_TRANSACTIONS_ERROR: 'PARTNER_READ_TRANSACTIONS_ERROR',
    PARTNER_READ_EVENTS_REQUEST: 'PARTNER_READ_EVENTS_REQUEST',
    PARTNER_READ_EVENTS_SUCCESS: 'PARTNER_READ_EVENTS_SUCCESS',
    PARTNER_READ_EVENTS_ERROR: 'PARTNER_READ_EVENTS_ERROR',
    PARTNER_READ_SWITCH_PLAN_INFO_REQUEST: 'PARTNER_READ_SWITCH_PLAN_INFO_REQUEST',
    PARTNER_READ_SWITCH_PLAN_INFO_SUCCESS: 'PARTNER_READ_SWITCH_PLAN_INFO_SUCCESS',
    PARTNER_READ_SWITCH_PLAN_INFO_ERROR: 'PARTNER_READ_SWITCH_PLAN_INFO_ERROR',

    PARTNER_READ_ADVISORS_REQUEST: 'PARTNER_READ_ADVISORS_REQUEST',
    PARTNER_READ_ADVISORS_SUCCESS: 'PARTNER_READ_ADVISORS_SUCCESS',
    PARTNER_READ_ADVISORS_ERROR: 'PARTNER_READ_ADVISORS_ERROR',
    PARTNER_CREATE_ADVISOR_REQUEST: 'PARTNER_CREATE_ADVISOR_REQUEST',
    PARTNER_CREATE_ADVISOR_SUCCESS: 'PARTNER_CREATE_ADVISOR_SUCCESS',
    PARTNER_CREATE_ADVISOR_ERROR: 'PARTNER_CREATE_ADVISOR_ERROR',
    PARTNER_READ_ADVISOR_REQUEST: 'PARTNER_READ_ADVISOR_REQUEST',
    PARTNER_READ_ADVISOR_SUCCESS: 'PARTNER_READ_ADVISOR_SUCCESS',
    PARTNER_READ_ADVISOR_ERROR: 'PARTNER_READ_ADVISORS_ERROR',
    PARTNER_UPDATE_ADVISOR_REQUEST: 'PARTNER_UPDATE_ADVISOR_REQUEST',
    PARTNER_UPDATE_ADVISOR_SUCCESS: 'PARTNER_UPDATE_ADVISOR_SUCCESS',
    PARTNER_UPDATE_ADVISOR_ERROR: 'PARTNER_UPDATE_ADVISORS_ERROR',
    PARTNER_DELETE_ADVISOR_REQUEST: 'PARTNER_DELETE_ADVISOR_REQUEST',
    PARTNER_DELETE_ADVISOR_SUCCESS: 'PARTNER_DELETE_ADVISOR_SUCCESS',
    PARTNER_DELETE_ADVISOR_ERROR: 'PARTNER_DELETE_ADVISORS_ERROR',
    PARTNER_INIT_ADVISOR: 'PARTNER_INIT_ADVISOR',

    PARTNER_RESET: 'PARTNER_RESET',

    read: subdomain => ({
        type: actions.PARTNER_READ_REQUEST,
        subdomain,
    }),
    updatePaymentMethod: request => ({
        type: actions.PARTNER_UPDATE_PAYMENT_METHOD_REQUEST,
        request,
    }),
    deletePaymentMethod: () => ({
        type: actions.PARTNER_DELETE_PAYMENT_METHOD_REQUEST,
    }),
    updatePartnerProfile: request => ({
        type: actions.PARTNER_UPDATE_PARTNER_PROFILE_REQUEST,
        request,
    }),
    createClient: request => ({
        type: actions.PARTNER_CREATE_CLIENT_REQUEST,
        request,
    }),
    readClients: request => ({
        type: actions.PARTNER_READ_CLIENTS_REQUEST,
        request,
    }),
    readClient: clientId => ({
        type: actions.PARTNER_READ_CLIENT_REQUEST,
        clientId,
    }),
    readBillingEstimate: () => ({
        type: actions.PARTNER_READ_BILLING_ESTIMATE_REQUEST,
    }),
    readReferrals: request => ({
        type: actions.PARTNER_READ_REFERRALS_REQUEST,
        request,
    }),
    changeSubscription: (id, request) => ({
        type: actions.PARTNER_CHANGE_SUBSCRIPTION_REQUEST,
        id,
        request,
    }),
    cancelSubscription: id => ({
        type: actions.PARTNER_CANCEL_SUBSCRIPTION_REQUEST,
        id,
    }),
    requestToTransfer: id => ({
        type: actions.PARTNER_REQUEST_TO_TRANSFER_REQUEST,
        id,
    }),
    subscribeSubscription: (id, request) => ({
        type: actions.PARTNER_SUBSCRIBE_SUBSCRIPTION_REQUEST,
        id,
        request,
    }),
    deleteClient: id => ({
        type: actions.PARTNER_DELETE_CLIENT_REQUEST,
        id,
    }),
    readTransactions: () => ({
        type: actions.PARTNER_READ_TRANSACTIONS_REQUEST,
    }),
    readSwitchPlanInfo: id => ({
        type: actions.PARTNER_READ_SWITCH_PLAN_INFO_REQUEST,
        id,
    }),

    readAdvisors: request => ({
        type: actions.PARTNER_READ_ADVISORS_REQUEST,
        request,
    }),
    readEvents: payload => ({
        type: actions.PARTNER_READ_EVENTS_REQUEST,
        payload,
    }),
    createAdvisor: request => ({
        type: actions.PARTNER_CREATE_ADVISOR_REQUEST,
        request,
    }),
    readAdvisor: id => ({
        type: actions.PARTNER_READ_ADVISOR_REQUEST,
        id,
    }),
    updateAdvisor: (id, request) => ({
        type: actions.PARTNER_UPDATE_ADVISOR_REQUEST,
        id,
        request,
    }),
    deleteAdvisor: (id, request) => ({
        type: actions.PARTNER_DELETE_ADVISOR_REQUEST,
        id,
        request,
    }),
    initAdvisor: advisor => ({
        type: actions.PARTNER_INIT_ADVISOR,
        advisor,
    }),
    reset: () => ({
        type: actions.PARTNER_RESET,
    }),
};

export default actions;
